module.exports = __webpack_public_path__ + "static/media/logo_colored.37b4cfb4.png";